import http from './http';
import { listResource } from './listResource';

export async function listPlans(options = {}) {
  return listResource('/plans', options);
}

/**
 * Obtiene un plan por su ID.
 */
export async function getPlanById(id) {
  const res = await http.get(`/plans/${id}`);
  return res.data?.data ?? res.data;
}

/**
 * Actualiza un plan.
 */
export async function updatePlan(id, data) {
  const res = await http.put(`/plans/${id}`, data);
  return res.data?.data ?? res.data;
}

/**
 * Crear un plan.
 */
export async function createPlan(data) {
  const res = await http.post(`/plans/`, data);
  return res.data?.data ?? res.data;
}

/**
 * Activar/Desactivar plan
 */
export const updatePlansStatus = (id, isActive) =>
  // eslint-disable-next-line camelcase
http.patch(`/plans/status/${id}`, { is_active: isActive });

/**
 * Eliminar plan
 */
export const deletePlan = (id) => http.delete(`/plans/${id}`);

export async function rateVideo(id, data) {
  const res = await http.put(`/plans/${id}/rate`, data);
  return res.data?.data ?? res.data;
}


/**
 * Revisar que no este en uso la plan.
 */
export async function checkPlanExists(title, excludeId = null) {
  try {
    const { items } = await listPlans({ search: title });
    const exists = items?.some(
      (item) =>
        item.description?.toLowerCase() === title?.toLowerCase() &&
        item.id !== Number(excludeId)
    );
    return exists;
  } catch (error) {
    console.error('Error al verificar el plan:', error);
    return false;
  }
}

export async function listPlanPermissions(options = {}) {
  const res = await listResource('/plans/permissions/actions', options);
  return res.data?.items ?? res.items ?? res.data?.data ?? res.data ?? [];
}
